import {
  CellContext,
  ColumnDef,
  createColumnHelper
} from "@tanstack/react-table";
import _ from "lodash";
import * as React from "react";

import { Text } from "src/library/components/Text";
import {
  ISupportTicket,
  ISupportTicketType
} from "src/modules/support/api/support.api";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { ITerminology } from "src/core/shared/api";
import { IRole } from "src/core/shared/api/roles.api";

export interface ISupportTicketColumns {
  actionButton: (info: CellContext<ISupportTicket, unknown>) => React.ReactNode,
  terminology: ITerminology
  ExcludedColumns?: SupportColumnPicked[]
  currentRole: IRole | null,
  supportTicketTypes: ISupportTicketType[] | null
}

type SupportColumnPicked = keyof AvailableSupportColumns;

interface AvailableSupportColumns{
priority: ColumnDef<ISupportTicket, unknown>,
id: ColumnDef<ISupportTicket, unknown>,
assingnedUser: ColumnDef<ISupportTicket, unknown>,
branch: ColumnDef<ISupportTicket, unknown>,
orderDeliveryDate: ColumnDef<ISupportTicket, unknown>,
customerReference: ColumnDef<ISupportTicket, unknown>,
origin: ColumnDef<ISupportTicket, unknown>,
stauts: ColumnDef<ISupportTicket, unknown>,
ticketType: ColumnDef<ISupportTicket, unknown>,
dateOfContact: ColumnDef<ISupportTicket, unknown>,
resolvedAt: ColumnDef<ISupportTicket, unknown>,
actions: ColumnDef<ISupportTicket, unknown>

}

export const getAdminSupportTicketColumns = (params: ISupportTicketColumns) => {
  const customColumnHelper = customCreateColumnHelper<ISupportTicket>();
  const columnHelper = createColumnHelper<ISupportTicket>();

  const AllColumns: AvailableSupportColumns = {
    priority: customColumnHelper.supportTicketPriorityColumn(columnHelper, "priority"),
    id: customColumnHelper.numberColumn(columnHelper, "id", {
      header: "Ticket Number",
      enableSorting: true,
      cell: info => {
        return (
          <Text>
            <>
              {`#${info.cell.getValue()}`}
            </>
          </Text>
        );
      }
    }),
    assingnedUser: customColumnHelper.supportTicketAssignedColumn(columnHelper, "assignedUser", {}),
    branch: customColumnHelper.standardTextColumn(columnHelper, "branch", {
      enableSorting: false,
      header: "Delivery Point",
      cell: info => {
        return (
          <Text>
            <>
              {info.row.original.branch?.branchNumber ?? "-"}
            </>
          </Text>
        );
      }
    }),
    orderDeliveryDate: customColumnHelper.dateColumn(columnHelper, "order.orderDeliveryDate", {
      header: "Delivery Date",
      enableSorting: false
    }),
    customerReference: customColumnHelper.standardTextColumn(columnHelper, "order.customerReference", {
      header: "PO Number",
      enableSorting: false
    }),
    origin: customColumnHelper.supportTicketOriginColumn(columnHelper, "origin"),
    stauts: customColumnHelper.supportTicketStatusColumn(columnHelper, "status", params.currentRole),
    ticketType: customColumnHelper.standardTextColumn(columnHelper, "supportTicketTypeId", {
      header: "Issue Type",
      enableColumnFilter: true,
      cell: info => {
        return (
          <Text weight="bold">
            <>
              {info.row.original.supportTicketType?.name}
            </>
          </Text>
        );
      },
      meta: {
        filter: {
          filterType: "select",
          options: params.supportTicketTypes?.map(type => {
            return ({
              text: _.capitalize(type.name),
              value: type.id.toString()
            });
          })
        }
      }
    }),
    dateOfContact: customColumnHelper.dateColumn(columnHelper, "dateOfContact", { header: "Date of Contact" }),
    resolvedAt: customColumnHelper.dateColumn(columnHelper, "resolvedAt", { header: "Resolved At" }),
    actions: customColumnHelper.actionColumn(columnHelper, params.actionButton, {})

  };

  if (params.ExcludedColumns) {
    const result = AllColumns;

    for (const col of params.ExcludedColumns) {
      delete result[ col ];
    }

    return Object.values(result);
  } else {
    return Object.values(AllColumns);
  }
};
